import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Button, Divider } from "@mui/material";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { infoNotify } from "../ToastComponent/ToastNotification";

const Settings = () => {
  const [selectedJobType, setSelectedJobType] = useState("");
  const [selectedJobLocation, setSelectedJobLocation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [resume, setResume] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const MAX_SIZE_MB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2); // rounded to 2 decimal places

    if (file.size > MAX_SIZE_BYTES) {
      infoNotify(
      `File size should be less than ${MAX_SIZE_MB} MB. Uploaded file size is ${fileSizeMB} MB`
      );
      return;
    }

    setResume(event.target.files[0]);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        System Settings
      </Typography>

      {/* PERSONAL INFORMATION */}
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Website Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Company Name
          </Typography>
          <TextInput label="Full Name" placeholder="Enter Company Name" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Company Email
          </Typography>
          <TextInput
            label="Email Address"
            placeholder="Enter Company Email Address"
            type="email"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Company Contact Number
          </Typography>
          <TextInput
            label="Phone Number"
            placeholder="Enter Company Phone Number"
            type="tel"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Company Address
          </Typography>
          <TextInput label="Address" placeholder="Enter Company Address" />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ADDITIONAL DETAILS */}
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Additional Details
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Upload Company Logo
          </Typography>
          <input
            accept="image/*"
            style={{ display: "none" }}
            id="resume-upload"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="resume-upload">
            <Button
              variant="contained"
              component="span"
              startIcon={<CloudUploadIcon />}
              sx={{
                backgroundColor: "#3498DB",
                color: "#fff",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {resume ? resume.name : "Choose File"}
            </Button>
          </label>
        </Grid>
      </Grid>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton variant="outlined" customColor="#B0BEC5">
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton variant="contained" customColor="#007BFF">
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Settings;
